import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL || '/';

const api = axios.create({
    baseURL,
});

api.defaults.headers.get['Cache-Control'] = 'no-cache';
api.defaults.cache = 'no-store';

api.interceptors.request.use(config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// ✅ FIXED: No more alert() - components handle errors
api.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)  // Pass raw error through
);

export default api;
